import React from "react";
import Icon from "../../../components/AppIcon";

const CalculationSummary = ({
  totalAmount,
  recipientCount,
  averageAmount,
  remainingBalance,
}) => {
  const summaryItems = [
    {
      label: "Total TRONC Amount",
      value: `£${totalAmount?.toFixed(2)}`,
      icon: "PoundSterling",
      color: "var(--color-primary)",
    },
    {
      label: "Number of Recipients",
      value: recipientCount?.toString(),
      icon: "Users",
      color: "var(--color-secondary)",
    },
    {
      label: "Average Distribution",
      value: `£${averageAmount?.toFixed(2)}`,
      icon: "TrendingUp",
      color: "var(--color-accent)",
    },
    {
      label: "Remaining Balance",
      value: `£${remainingBalance?.toFixed(2)}`,
      icon: remainingBalance === 0 ? "CheckCircle2" : "AlertCircle",
      color:
        remainingBalance === 0
          ? "var(--color-success)"
          : "var(--color-warning)",
    },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 lg:p-8">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Calculator" size={20} color="var(--color-accent)" />
        </div>
        <h2 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-foreground">
          Calculation Summary
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {summaryItems?.map((item, index) => (
          <div
            key={index}
            className="bg-background rounded-lg p-4 md:p-6 border border-border"
          >
            <div className="flex items-center gap-3 mb-2 md:mb-3">
              <Icon name={item?.icon} size={20} color={item?.color} />
              <span className="text-xs md:text-sm font-caption text-muted-foreground">
                {item?.label}
              </span>
            </div>
            <p className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground whitespace-nowrap">
              {item?.value}
            </p>
          </div>
        ))}
      </div>
      {remainingBalance !== 0 && (
        <div className="mt-4 md:mt-6 p-3 md:p-4 bg-warning/10 border border-warning/20 rounded-lg flex items-start gap-3">
          <Icon
            name="AlertTriangle"
            size={20}
            color="var(--color-warning)"
            className="flex-shrink-0 mt-0.5"
          />
          <div>
            <p className="text-sm md:text-base font-caption font-semibold text-warning mb-1">
              Distribution Incomplete
            </p>
            <p className="text-xs md:text-sm text-muted-foreground">
              £{Math.abs(remainingBalance)?.toFixed(2)}{" "}
              {remainingBalance > 0
                ? "remaining to distribute"
                : "over-distributed"}
              . Please adjust employee amounts.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CalculationSummary;
